import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import {Account} from "models"
import classNames from "classnames"
import memo from "set-state-compare/build/memo"
import Nav from "components/nav"
import NavItem from "components/nav/item"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"

export default memo(shapeComponent(class RoutesAdminAccountsNav extends ShapeComponent {
  static propTypes = {
    account: PropTypes.instanceOf(Account).isRequired,
    active: PropTypes.string,
    className: PropTypes.string
  }

  setup() {
    const {t} = useI18n({namespace: "js.components.admin.accounts.nav"})

    this.t = t
  }

  render() {
    const {account, active, className, ...restProps} = this.props

    return (
      <Nav className={classNames("routes--admin--accounts--nav", className)} {...restProps}>
        <NavItem active={active} identifier="general" label={this.t("js.shared.general")} to={Routes.adminAccountPath(account.id())} />
        <NavItem
          active={active}
          identifier="users"
          label={Account.humanAttributeName("users")}
          to={Routes.adminAccountAccountUsersPath(account.id())}
        />
        <NavItem
          active={active}
          identifier="schools"
          label={Account.humanAttributeName("schools")}
          to={Routes.adminAccountAccountSchoolsPath(account.id())}
        />
      </Nav>
    )
  }
}))
